import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import { formatMoney, toFriendlyDateString } from 'helpers/Formatter';
import {
  Card,
  Header,
  Body,
  BoldTitle,
  BoldText,
  GreyText,
  VerticalDivider,
  HorizontalDivider,
  MobileItem,
  StyledArrowButton,
} from '../common/Card';
import MediaQuery from 'react-responsive';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIosOutlined';

const ProposalCard = ({ proposal, index, handleSelection }) => {
  const { lease_from_date, lease_to_date, min_term, max_term, rent, special, other } = proposal;

  const sum = (a, b, c) => {
    // Rental amouts come from yardi as strings I.E.
    // rent: '1095.000000',
    // special: '-30.000000',
    // other: '0.000000'
    return formatMoney([a, b, c].reduce((prev, current) => parseFloat(prev) + parseFloat(current)));
  };

  const minMaxTermToFriendlyString = (minTerm, maxTerm) => {
    if (minTerm === maxTerm) {
      return getTranslatedString('landlordPortal.rentRoll.renewals.months', { term: minTerm });
    } else {
      return getTranslatedString('landlordPortal.rentRoll.renewals.leaseTermRange', {
        minTerm,
        maxTerm,
      });
    }
  };

  const handleClick = () => {
    if (handleSelection) {
      handleSelection(index);
    }
  };

  return (
    <React.Fragment>
      <MediaQuery query="(min-device-width: 750px)">
        <Card onClick={handleClick} cursor="pointer">
          <Header>
            <BoldTitle>
              {getTranslatedString('landlordPortal.rentRoll.renewals.renewalProposalN', {
                n: index + 1,
              })}
            </BoldTitle>
          </Header>
          <HorizontalDivider />
          <Body>
            <div>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.startDate')}
              </GreyText>
              <BoldText>{toFriendlyDateString(lease_from_date)}</BoldText>
            </div>
            <VerticalDivider />
            <div>
              <GreyText>{getTranslatedString('landlordPortal.rentRoll.renewals.endDate')}</GreyText>
              <BoldText>{toFriendlyDateString(lease_to_date)}</BoldText>
            </div>
            <VerticalDivider />
            <div>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.leaseTerms')}
              </GreyText>
              <BoldText>{minMaxTermToFriendlyString(min_term, max_term)}</BoldText>
            </div>
            <VerticalDivider />
            <div>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.monthlyRent')}
              </GreyText>
              <BoldText>{sum(rent, special, other)}</BoldText>
            </div>
          </Body>
        </Card>
      </MediaQuery>

      <MediaQuery query="(max-device-width: 750px)">
        <Card onClick={handleClick}>
          <Header>
            <BoldTitle>
              {getTranslatedString('landlordPortal.rentRoll.renewals.renewalProposalN', {
                n: index + 1,
              })}
            </BoldTitle>
            <StyledArrowButton>
              <ArrowForwardIosIcon />
            </StyledArrowButton>
          </Header>
          <HorizontalDivider />
          <Body>
            <MobileItem borderRight>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.startDate')}
              </GreyText>
              <BoldText>{lease_from_date}</BoldText>
            </MobileItem>
            <MobileItem textAlign="right">
              <GreyText>{getTranslatedString('landlordPortal.rentRoll.renewals.endDate')}</GreyText>
              <BoldText>{lease_to_date}</BoldText>
            </MobileItem>
          </Body>
          <HorizontalDivider />
          <Body>
            <MobileItem borderRight>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.monthlyRent')}
              </GreyText>
              <BoldText>{sum(rent, special, other)}</BoldText>
            </MobileItem>
            <MobileItem textAlign="right">
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.leaseTerms')}
              </GreyText>
              <BoldText>{minMaxTermToFriendlyString(min_term, max_term)}</BoldText>
            </MobileItem>
          </Body>
        </Card>
      </MediaQuery>
    </React.Fragment>
  );
};

export default ProposalCard;
